<template>
  <div class="block">
    <Sidebar />

    <router-view name="production" v-slot="{ Component }">
      <transition name="up" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'Production',

  components: {
    Sidebar
  },
}
</script>

<style>
</style>
